import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import {any, assocPath, compose, mapObjIndexed, not, values, pick, trim} from "ramda";

import {PageHead} from 'components/header/components';
import Box from 'components/box';
import {Error} from 'components/errors';
import Input from 'form/input';
import Textarea from 'form/textarea';
import Breadcrumbs from 'components/breadcrumbs';
import {ButtonDefault} from 'components/buttons';

import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import close from 'images/general/close.svg';

import {submitService, serviceCleanStore, loadServiceDetail, serviceSubmitFailed} from 'redux/actions/admin/services';

const mapStateToProps = (state) => ({
  detail: state.adminService.get('serviceDetail'),
  isSubmitting: state.adminService.get('serviceIsSubmitting'),
  hasError: state.adminService.get('serviceSubmitFailed')
})

const mapDispatchToProps = (dispatch) => ({
  onMount: id => dispatch(loadServiceDetail(id)),
  onSubmit: (serviceData, id = null) => dispatch(submitService('/admin/services/detail/', serviceData, id)),
  onClean: () => dispatch(serviceCleanStore()),
  cleanError: () => dispatch(serviceSubmitFailed(false))
})

class CreateService extends Component {
  state = {
    serviceData: {
      code: '',
      title: '',
      title_classification: '',
      description: '',
      instruction: '',
      additional_info: ''
    },
    errors: {
      code: false,
      title: false,
      title_classification: false,
      description: false,
      instruction: false,
      additional_info: false
    },
    formValid: true,
    modalOpen: false
  }

  openModal = () => {
    const isFalse = value => Boolean(value)
    if(any(isFalse, values(this.state.serviceData))){
      this.toggleModal()
      return
    }
    this.props.history.goBack()
  }

  toggleModal = () => this.setState(prevState => ({modalOpen: !prevState.modalOpen}))

  onModalOk = () => {
    this.toggleModal()
    this.props.history.goBack()
  }

  renderValue = key => {
      return this.state.serviceData[key]
  }

  renderInputs = () => {
    const inputs = [
      {
        label: "Код послуги:",
        type: "text",
        placeholder: "Введіть код послуги",
        key: 'code',
        required: true,
        maxLength: 16
      },
      {
        label: "Назва послуги для відображення на порталі:",
        type: "text",
        placeholder: "Введіть назву послуги",
        key: 'title',
        required: true,
        maxLength: 255
      },
      {
        label: "Назва послуги згідно з класифікатором медичних послуг:",
        type: "text",
        placeholder: "Введіть назву послуги",
        key: 'title_classification',
        required: true,
        maxLength: 200
      }
    ]
    return inputs.map(field => {
      return <Input
        key={field.key}
        label={field.label}
        type={field.type}
        required={field.required}
        placeholder={field.placeholder}
        max={field.maxLength}
        value={this.renderValue(field.key)}
        hasError={this.state.errors[field.key]}
        onChange={(event) => this.onValueChange(event.target.value, field.key)}
      />
    })
  }

  renderTextareas = () => {
    const textareas = [
      {
        label: "Опис послуги:",
        type: "text",
        placeholder: "Введіть опис та перелік послуг",
        key: 'description',
        maxLength: 2000
      },
      {
        label: "Підготовка до отримання послуги:",
        type: "text",
        placeholder: "Введіть дані про підготовку пацієнта до отримання послуги",
        key: 'instruction',
        maxLength: 2000
      },
      {
        label: "Додаткові відомості та особливості:",
        type: "text",
        placeholder: "Введіть особливості та застереження, якщо вони є",
        key: 'additional_info',
        maxLength: 500
      }
    ]
    return textareas.map(field => {
      return (
      <Textarea
        key={field.key}
        label={field.label}
        type={field.type}
        max={field.maxLength}
        placeholder={field.placeholder}
        value={this.renderValue(field.key)}
        onChange={(event) => this.onValueChange(event.target.value, field.key)}
      />)
    })
  }

  onValueChange(value, key) {
    let createNewState = compose(assocPath(['serviceData', key], value), assocPath(['errors', key], false))
    this.setState(prevState => createNewState(prevState))
  }

  async onSubmit (event, id) {
    event.preventDefault()
    await this.trimObjValues(this.state.serviceData)
    let requiredFields = ['code', 'title', 'title_classification']
    await this.validateForm(requiredFields)
    if(not(this.state.formValid)) return
    this.props.onSubmit(this.state.serviceData, id)
  }

  validateForm(requiredFields = null) {
    let fields = requiredFields ? pick(requiredFields, this.state.serviceData) : this.state.serviceData
    let errors = {}
    mapObjIndexed((value, key) => {
      let valueError = !value
      errors = assocPath([key], valueError, errors)
    }, fields)
    let isInvalid = value => value
    if(any(isInvalid, values(errors))) {
      this.setState(() => ({ errors, formValid: false }))
    } else {
      this.setState(() => ({ errors, formValid: true }))
    }
  }

  trimObjValues = objToTrim => {
    const trimmedObj = mapObjIndexed(trim, objToTrim)
    this.setState(() => ({ serviceData: trimmedObj}))
  }

  generateError = (error) => {
    let msg = ''
    if(error && error.code){
      msg = 'Послуга з таким кодом вже існує. Введіть, будь ласка, інший код.'
    } else if(error) {
      msg = ' При збереженні даних виникла проблема. Перевірте, будь ласка, всі поля.'
    } else {
      return
    }
    return (
      <Error>
        {msg}
      </Error>
    )
  }

  componentDidMount() {
    this.props.cleanError();
    if (this.props.match.params.service_id) {
      this.props.onMount(this.props.match.params.service_id)
    } else {
      this.props.onClean();
    }
  }

  componentWillReceiveProps (nextProps) {
    if(this.props.match.params.service_id && nextProps.detail && not(this.state.serviceData.code)) {
      this.setState(prevState => ({
        serviceData: {
          code: nextProps.detail.get('code'),
          title: nextProps.detail.get('title'),
          title_classification: nextProps.detail.get('title_classification'),
          description: nextProps.detail.get('description'),
          instruction: nextProps.detail.get('instruction'),
          additional_info: nextProps.detail.get('additional_info'),
        }
      }))
    }
  }

  componentWillUnmount() {
    this.props.cleanError();
    this.props.onClean();
  }


  render() {
    return (
      <div>
          <Breadcrumbs>
              <li><Link to="/admin/">Головна</Link></li>
              <li><Link to="/admin/services/">Послуги</Link></li>
              {this.props.match.params.service_id ? (
                  <li><Link to="/admin/services/create">Редагування послуги</Link></li>
              ):(
                  <li><Link to="/admin/services/create">Створення послуги</Link></li>
              )}

          </Breadcrumbs>
        <PageHead>
          <h2>{this.props.match.params.service_id ? "Редагувати послугу" : "Додати послугу" }</h2>
        </PageHead>

        <Box title4={this.props.match.params.service_id ? "Форма редагування послуги" : "Форма додавання послуги"}>
          <form onSubmit={(event) => this.onSubmit(event, this.props.match.params.service_id)}>
            {this.renderInputs()}
            {this.renderTextareas()}
            <ButtonDefault disabled = {this.props.isSubmitting} type="submit" value="Зберегти"/>
              <ButtonDefault onClick={this.openModal} value="Вийти без збереження"/>
          </form>

          {this.generateError(this.props.hasError)}
        </Box>

        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                    className={{
                      base: 'modalContent',
                      afterOpen: 'myClass_after-open',
                      beforeClose: 'myClass_before-close'
                    }} contentLabel="Підтвердження запису"
                    overlayClassName={{
                      base: 'modalOverlay',
                      afterOpen: 'myOverlayClass_after-open',
                      beforeClose: 'myOverlayClass_before-close'
                    }}>
          <div>
            <Modal>
              <CloseModal>
                <div>
                  <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
              </CloseModal>

              <ModalContent>
                <h3>
                  Ви впевнені, що хочете вийти без збереження?
                  Всі внесені зміни будуть скасовані
                </h3>
                <ButtonWrap>
                  <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>

            </Modal>
          </div>
        </ReactModal>
      </div>
    )
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateService);



// WEBPACK FOOTER //
// ./src/admin/services/create.js